export const isMale = (userSettings) => {
    return userSettings && userSettings.userData && userSettings.userData.gender === 'MALE';
};

export const hasMBTesterRole = (viewerSocialProfile) => {
    return (
        viewerSocialProfile &&
        viewerSocialProfile.userRoles &&
        viewerSocialProfile.userRoles.indexOf('ROLE_MBTESTER') !== -1
    );
};

export const getFeatureEnabledForMultipleRoles = (userRolesListPreference, viewerSocialProfile) => {
    const userRoles = viewerSocialProfile.userRoles;
    const userRolesList = userRolesListPreference.value.split(',');
    for (let i = 0; i < userRolesList.length; i++) {
        if (userRoles.indexOf(userRolesList[i].trim()) >= 0) {
            return true;
        }
    }
    return false;
};

/**
 * Function to check whether we should hide "Pulse Ox"/"SpO2" related contents for Japan Users
 *
 * The Medical Law of Japan doesn't allow wordings like "Pulse Ox", "SpO2", so we need to hide related contents to avoid violating the low,
 * when user has set the country to Japan AND is using non-Japanese as the display laugnage
 *   1. User has set Japan as country/location, i.e. userInfo.countryCode === 'JP'
 *   2. User is using non-Japanese as the display language, i.e. userInfo.locale !== 'ja'
 *      * Notes: when the language is set to Japanese, related terms would be translated to "血中酸素", which is legal and valid in Japan
 * @param {object} userPersonalInfo
 * @returns {boolean} true: able to show the related contents / false: we need to hide related contents
 */
export const isAbleToHavePulseOxFeature = (userPersonalInfo) => {
    return (
        userPersonalInfo &&
        userPersonalInfo.userInfo &&
        userPersonalInfo.userInfo.locale &&
        userPersonalInfo.userInfo.countryCode &&
        (userPersonalInfo.userInfo.countryCode !== 'JP' || userPersonalInfo.userInfo.locale === 'ja')
    );
};
